import $ from "jquery";

window.$ = window.jQuery = $;

$( document ).ready(
	function () {
		let $links    = $( 'a:contains(@email)' );
		const pattern = /\(\'(?<hash>.+)\'\)/;

		$links.each(
			function ( index, link ) {
				let match = $( link ).attr( 'href' ).match( pattern );
				if (
					match &&
					typeof match[ 'groups' ] !== 'undefined' &&
					typeof match[ 'groups' ][ 'hash' ] !== 'undefined'
				) {
					let hash    = match[ 'groups' ][ 'hash' ];
					let address = DeCryptString( hash );
					$( link ).html( address.replace( 'mailto:', '' ) );
				}
			}
		);

		function DeCryptString( s ) {
			let n    = 0;
			let r    = "mailto:";
			let z    = 0;
			let sLen = s.length;
			for ( let i = 0; i < sLen / 2; i++ ) {
				z = s.substr( i * 2, 1 );
				n = s.charCodeAt( i * 2 + 1 );
				if ( n >= 8364 ) {
					n = 128;
				}
				r += String.fromCharCode( n - z );
			}
			return r;
		}

		function DeCryptX( s ) {
			location.href = DeCryptString( s );
		}

		window.DeCryptX = DeCryptX;
	}
);
